import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import FinanceCardChart from "../../finance/financeCardChart/financeCardChart";
import InfoIcon from "../../../assets/icons/info-icon.svg";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const EducationDebtsPeriod = ({ agePeriod, code }) => {
  const [showPopover, setShowPopover] = useState(false);

  const data = {
    labels: ["Idade"],
    datasets: [
      {
        label: "De 0 a 18 anos",
        data: [agePeriod?.ageGroup_0_18],
        backgroundColor: "#0962AD"
      },
      {
        label: "Entre 18 e 25 anos",
        data: [agePeriod?.ageGroup_18_25],
        backgroundColor: "#E4C566"
      },
      {
        label: "Entre 25 e 35 anos",
        data: [agePeriod?.ageGroup_26_35],
        backgroundColor: "#DA5252"
      },
      {
        label: "Entre 35 e 45 anos",
        data: [agePeriod?.ageGroup_36_45],
        backgroundColor: "#2BAD70"
      },
      {
        label: "Acima de 45 anos",
        data: [agePeriod?.moreThan40],
        backgroundColor: "#0962AD"
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxHeight: 6,
          color: "#858585",
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`
        }
      }
    },
    scales: {
      y: {
        grid: {
          color: "#D2D5DA"
        },
        border: {
          dash: [2, 5]
        },
        ticks: {
          callback: function (value) {
            return value;
          }
        }
      }
    }
  };

  return (
    <FinanceCardChart
      code={code}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>Idade dos Alunos</span>
          <div style={{ position: 'relative' }}>
            <img
              src={InfoIcon}
              alt="Informação"
              onClick={() => setShowPopover(!showPopover)}
              style={{
                width: '14px',
                height: '14px',
                cursor: 'pointer',
                verticalAlign: 'middle',
                display: 'inline-block'
              }}
            />
            {showPopover && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "100%",
                  transform: "translate(0, -50%)",
                  marginLeft: "8px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  padding: "10px",
                  zIndex: 100,
                  width: "220px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px"
                }}
              >
                <p style={{ margin: 0, fontSize: "12px", fontWeight: "normal" }}>
                  Gráfico apresenta a distribuição percentual dos alunos por faixas etárias: até 17, 18-25, 26-35, 36-45 e 46 ou mais, revelando o perfil etário dos estudantes.                </p>
                <button
                  onClick={() => setShowPopover(false)}
                  style={{
                    marginTop: "8px",
                    fontSize: "10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "#0962AD"
                  }}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      }
    >
      <Bar data={data} options={options} />
    </FinanceCardChart>
  );
};

export default EducationDebtsPeriod;
